import { render, staticRenderFns } from "./V2Checkbox.vue?vue&type=template&id=1e936c1c&scoped=true&"
import script from "./V2Checkbox.vue?vue&type=script&lang=js&"
export * from "./V2Checkbox.vue?vue&type=script&lang=js&"
import style0 from "./V2Checkbox.vue?vue&type=style&index=0&id=1e936c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e936c1c",
  null
  
)

export default component.exports